import mitt from 'mitt';
import selectAll from './select-all';

export default class SlideShow {
  constructor({ element, duration = 12 }) {
    Object.assign(this, mitt());

    // private
    this._el = element;
    this._duration = duration;
    this._currentIndex = 0;
    this._photos = selectAll('.slideshow__photo', this._el);
    this._numPhotos = this._photos.length;
    this._slideTimeout = null;
  }

  start() {
    this._el.classList.remove('hidden');
    this._tick();
  }

  _tick() {
    this.show(this._currentIndex);
    this._currentIndex++;

    if (this._currentIndex === this._numPhotos) this._currentIndex = 0;

    this._slideTimeout = setTimeout(() => {
      this._tick();
    }, this._duration * 1000);
  }

  stop() {
    clearTimeout(this._slideTimeout);
    this._el.classList.add('hidden');
    this._currentIndex = 0;
    this._hideAll();
  }

  show(idx) {
    console.log(this._currentIndex);
    this._hideAll();
    this._photos[idx].classList.add('appear');
  }

  _hideAll() {
    this._photos.forEach(photo => {
      photo.classList.remove('appear');
    });
  }
}



// WEBPACK FOOTER //
// ./utils/slide-show.js